<template>
    <div class="card">
        <div class="d-flex gap-50">
            <span>Auth: {{ data.authentication_number }}</span>
            <span>{{ data.product.name }}</span>
            <span class="text-primary ml-auto">${{ data.product.price.formatted }} <span>Each</span></span>
        </div>
        <div class="d-flex gap-50 mid-div">

            <div class="">
                <img :src="data.product.base_image" alt=""
                     @click="$bvModal.show(modalName())">
            </div>


            <div class="d-flex flex-column gap-10">
                <div class="prop">
                    <span class="label">Banknote Owner</span>
                    <span class="value">{{ data.owner_name }}</span>
                </div>
                <div class="prop">
                    <span class="label">Serial Number</span>
                    <span class="value">{{ data.serial_number }}</span>
                </div>
                <div class="prop">
                    <span class="label">Registered On</span>
                    <span class="value">{{ data.registered_on }}</span>
                </div>
                <div class="prop">
                    <span class="label">Denomination</span>
                    <span class="value">{{ data.product.denomination.name }}</span>
                </div>
                <div class="prop">
                    <span class="label">Year</span>
                    <span class="value">{{ data.product.year }}</span>
                </div>
                <div class="prop">
                    <span class="label">Central Bank</span>
                    <span class="value">{{ data.product.central_bank }}</span>
                </div>
            </div>


            <div class="prop flex-column last-col">
                <span>Verified Security Features</span>
                <span class="value">{{ data.product.verified_security_feature }}</span>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <a :href="transferLink" class="text-uppercase btn btn-primary" variant="primary">Transfer ownership</a>
        </div>
        <b-modal hide-footer hide-header centered :id="modalName()">
            <div class="w-100">
                <img :src="data.product.base_image" :alt="data.product.name">
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "Card",
    props: ['data'],
    methods: {
        modalName() {
            return 'image-' + this.data.id
        }
    },
    computed: {
      transferLink() {
        return "/transfer-ownership?auth_number=" + this.data.authentication_number
      }
    }
}
</script>


<style scoped lang="scss">
.card {
    background-color: #F3F3F3;
    border-radius: 4px;
    display: flex;
    padding: 20px;
    gap: 10px;

    .gap-50 {
        gap: 50px;
    }

    img {
        width: 11.5rem;
        height: 11.5rem;
        object-fit: contain;
    }

    .prop {
        display: flex;
        gap: 10px;

        .label {
            min-width: 10rem;
        }

        .value {
            color: #535353
        }
    }

    .last-col {
        border-left: 1px solid #0010141A;
        padding-left: 1rem;
    }
}

@media screen and (max-width: 1000px) {
    .last-col {
        border-left: unset;
    }
    .mid-div {
        flex-direction: column;
    }
}
</style>

